// extracted by mini-css-extract-plugin
export var arrow = "open-position-module--arrow--27CKJ";
export var contact = "open-position-module--contact--fWpwr";
export var container = "open-position-module--container---C-ea";
export var description = "open-position-module--description--3xtt6";
export var descriptionContainer = "open-position-module--description-container--rMnKX";
export var join = "open-position-module--join--sfTty";
export var submit = "open-position-module--submit--naxw4";
export var title = "open-position-module--title--VfEvW";